<script lang="ts">
	import type { ChartDataPoint, StatsPeriod } from '$entities/stats';
	import { LineChart } from '$lib/shared/ui';
	import { formatChartLabel } from '$lib/shared/lib/statsFormatters';

	interface Props {
		chartData: ChartDataPoint[];
		period: StatsPeriod;
		title?: string;
	}

	let { chartData, period, title = 'Gross Tip Value' }: Props = $props();

	function toLineChartData(data: ChartDataPoint[]) {
		let revenue = data?.map((d) => ({ x: d.bucket_epoch, y: d.revenue })) ?? [];
		return [revenue];
	}

	function formatTooltip(value: number) {
		return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
	}

	function formatYAxis(value: number) {
		return `$${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
	}

	function formatXAxis(value: number) {
		return formatChartLabel(value, period);
	}
	let data = $derived(toLineChartData(chartData));
</script>

{#if chartData && chartData.length > 0}
	<div class="card p-4">
		<h4 class="mb-4 h4">{title}</h4>
		<div class="h-64">
			<LineChart {data} {formatTooltip} {formatYAxis} {formatXAxis} />
		</div>
	</div>
{/if}
